import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import React from 'react'
import { FaHeart, FaImages, FaQuoteLeft, FaCheckCircle, FaStar, FaExpandAlt } from 'react-icons/fa'
import './ResponseCanvas.css'

export default function ResponseCanvas({ showModalResponse, handleClose, handleSelectResponse, saveResponse, responses = [], imagesSelected, handleChangePhrase }) { 
  
  const [showImageViewer, setShowImageViewer] = React.useState(false)
  const [selectedImage, setSelectedImage] = React.useState(null)

  const handleImageClick = (imageSrc, event) => {
    event.stopPropagation() // Evitar que se seleccione la imagen al hacer clic
    setSelectedImage(imageSrc)
    setShowImageViewer(true)
  }

  const handleCloseImageViewer = () => {
    setShowImageViewer(false)
    setSelectedImage(null)
  }
  
  return (
    <Modal 
      className='response-modal' 
      show={showModalResponse} 
      onHide={handleClose} 
      size='xl'
      centered
    >
      <Modal.Header closeButton className='response-modal-header'>
        <div className='response-header-content'>
          <div className='response-title-section'>
            <div className='response-icon'>
              <FaImages />
            </div>
            <div className='response-title-text'>
              <h4 className='response-title'>¡Comparte tu experiencia!</h4>
              <p className='response-subtitle'>
                Selecciona las imágenes que mejor representen tu respuesta
              </p>
            </div>
          </div>
          <div className='response-encouragement'>
            <FaStar className='sparkle-icon' />
            <span>¡Tu voz importa!</span>
          </div>
        </div>
      </Modal.Header>
      
      <Modal.Body className='response-modal-body'>
        <div className='response-grid'>
          {responses.map((response, index) => (
            <div className={`response-image-card ${imagesSelected.includes(response.imageId) ? 'selected' : ''}`} key={index}>
              <div 
                className='image-container'
                onClick={() => handleSelectResponse({ imageId: response.imageId, response })}
              >
                <img
                  src={response.image}
                  alt='Imagen para seleccionar'
                  className='response-image'
                />
                <div className='image-overlay'>
                  {imagesSelected.includes(response.imageId) ? (
                    <FaCheckCircle className='check-icon' />
                  ) : (
                    <FaHeart className='heart-icon' />
                  )}
                </div>
                <div 
                  className='expand-icon'
                  onClick={(e) => handleImageClick(response.image, e)}
                >
                  <FaExpandAlt />
                </div>
                {imagesSelected.includes(response.imageId) && (
                  <div className='selected-indicator'>
                    <FaCheckCircle />
                  </div>
                )}
              </div>
              
              {imagesSelected.includes(response.imageId) && (
                <div className='phrase-input-container'>
                  <div className='input-icon'>
                    <FaQuoteLeft />
                  </div>
                  <input
                    type='text'
                    className='phrase-input'
                    placeholder='Comparte una frase que acompañe esta imagen...'
                    defaultValue={response.phrase}
                    value={response.phrases}
                    onChange={(e) => handleChangePhrase(e, index, response.imageId)}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
        
        {imagesSelected.length > 0 && (
          <div className='response-summary'>
            <div className='summary-content'>
              <FaImages className='summary-icon' />
              <span className='summary-text'>
                Has seleccionado {imagesSelected.length} imagen{imagesSelected.length > 1 ? 'es' : ''}
              </span>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className='response-modal-footer'>
        <div className='footer-content'>
          <div className='footer-message'>
            <FaHeart className='heart-icon-small' />
            <span>¡Gracias por compartir tu perspectiva!</span>
          </div>
          <button className='save-response-btn' onClick={saveResponse}>
            <FaCheckCircle className='btn-icon' />
            Guardar Respuesta
          </button>
        </div>
      </Modal.Footer>

      {/* Modal de Imagen Ampliada */}
      <Modal 
        show={showImageViewer} 
        onHide={handleCloseImageViewer}
        size="lg"
        centered
        className="image-viewer-modal"
      >
        <Modal.Body>
          {selectedImage && (
            <div className="image-viewer-container">
              <div className="image-viewer-header">
                <h5 className="image-viewer-title">
                  Vista Ampliada
                </h5>
                <button 
                  className="image-viewer-close"
                  onClick={handleCloseImageViewer}
                >
                  ×
                </button>
              </div>
              
              <img 
                src={selectedImage} 
                alt="Imagen ampliada" 
                className="image-viewer-image"
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Modal>
  )
}